export const firebaseConfig = {
    apiKey: "AIzaSyBHwqiYzux-XhvqlfnUvRsUCHw1xCahrF4",
    authDomain: "admgb-82a5f.firebaseapp.com",
    projectId: "admgb-82a5f",
    storageBucket: "admgb-82a5f.appspot.com",
    messagingSenderId: "568090658021",
    appId: "1:568090658021:web:39a5d4a7f375bd43dbc00c",
    measurementId: "G-K80LT06EQT"
  };